import GrayHeaderCard from "../../../../../../../../ui/cards/gray-header-card/GrayHeaderCard";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import OffertePianoOpzioneTable from "../../offerte-piano-opzione-table/OffertePianoOpzioneTable";

const PianoOpzioniCard = (props) => {
    const cardTitle = <Typography variant="subtitle1">
        {props.cardTitle}
    </Typography>

    return <GrayHeaderCard title={cardTitle}>
        <>
            {props.tableOneDescription ? <Typography variant="subtitle1"
                                                     className='ml-12'>
                    {props.tableOneDescription}
                </Typography>
                : null}

            <OffertePianoOpzioneTable
                comesFromConsip={props.comesFromConsip}
                isPachetti={props.isPachetti}
                optionsTable={props.optionsTable}
                data={props.tableOneData}
                loading={props.loading}
                hasTableRowClick={true}
            />

            {props.tableTwoData ? <>
                    <Typography variant="subtitle1"
                                className='ml-12 mt-24'>
                        {props.tableTwoDescription}
                    </Typography>

                    <OffertePianoOpzioneTable
                        isPachetti={props.isPachetti}
                        comesFromConsip={props.comesFromConsip}
                        data={props.tableTwoData}
                        loading={props.loading}
                        hasTableRowClick={true}
                    />
                </>
                : null}

            {props.tableThreeData ? <>
                <Typography variant="subtitle1"
                            className='ml-12 mt-24'>
                    {props.tableThreeDescription}
                </Typography>

                <OffertePianoOpzioneTable
                    isPachetti={props.isPachetti}
                    comesFromConsip={props.comesFromConsip}
                    data={props.tableThreeData}
                    loading={props.loading}
                    hasTableRowClick={true}
                />
            </>
                : null}
        </>
    </GrayHeaderCard>
}

PianoOpzioniCard.propTypes = {
    cardTitle: PropTypes.string.isRequired,
    tableOneDescription: PropTypes.string,
    tableOneData: PropTypes.array.isRequired,
    tableTwoDescription: PropTypes.string,
    tableTwoData: PropTypes.array,
    loading: PropTypes.bool.isRequired,
    tableThreeDescription: PropTypes.string,
    tableThreeData: PropTypes.array,
}

export default PianoOpzioniCard;